import * as React from 'react';
import { LoadingButton } from '@mui/lab';
import { Typography, Divider, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { MuiModal } from 'ui/MuiModal';

type IProps = {
    open: boolean;
    noBackdropClick?: boolean;
    title: React.ReactNode;
    content: string;
    confirmLabel?: string;
    showClose?: boolean;
    cancelLabel?: string;
    onCancel: () => void;
    onClose?: () => void;
    loading?: boolean;
    onConfirm: () => void;
};

export function RuleScheduleTaskNotificationPrompt({
    open,
    noBackdropClick,
    title,
    content,
    confirmLabel,
    showClose = false,
    cancelLabel,
    onCancel,
    loading,
    onConfirm,
    onClose
}: IProps) {
    return (
        <MuiModal open={open} onClose={noBackdropClick ? undefined : onClose}>
            <>
                <Box display="flex" alignItems="center">
                    <Box flexGrow={1}>
                        <Typography variant="h5" color="primary">
                            {title}
                        </Typography>
                    </Box>
                    {showClose && (
                        <Box>
                            <IconButton onClick={onClose}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    )}
                </Box>
                <Divider sx={{ my: 2, mx: 0 }} />
                <Typography sx={{ whiteSpace: 'pre-wrap' }} variant="body1">
                    {content}
                </Typography>
                <Divider sx={{ my: 2, mx: 0 }} />
                <Box justifyContent="flex-end" sx={{ width: '100%', display: 'flex' }}>
                    <LoadingButton
                        sx={{ mr: 2.25 }}
                        variant="outlined"
                        color="primary"
                        disabled={loading}
                        loading={loading}
                        onClick={onCancel}
                    >
                        {cancelLabel || 'Cancel'}
                    </LoadingButton>
                    <LoadingButton
                        loading={loading}
                        disabled={loading}
                        variant="contained"
                        color="primary"
                        onClick={onConfirm}
                    >
                        {confirmLabel || 'Confirm'}
                    </LoadingButton>
                </Box>
            </>
        </MuiModal>
    );
}
